import React from "react";
import CrudErrors from "components/CrudErros";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

const LineCrudTableForm = ({setForm, form, createData, updateData, handleReset, errors}) => {

    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    const handleChangeSelect = (e) => {
        var optionSelected = parseInt(document.querySelector('#type').value);
        if (optionSelected !== 0) {
            setForm({...form, [e.target.name]: e.target.value});
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (form._id === null) {
            createData(form);
        } else {
            updateData(form);
        }
    }
    let myAbi = HelpAbility();
    const isVisibleForm = () => (form._id === null) ? myAbi.has(C.A.LINE.CREATE) : myAbi.has(C.A.LINE.UPDATE);

    return (
        <>
            {isVisibleForm() && <div className="mt-4">
                <div className="row mb-2">
                    <h6>{form._id ? 'Editar' : 'Agregar'} Línea</h6>
                </div>
                {errors && <CrudErrors errors={errors}/>}

                <div className="table-responsive rounded-3"
                     style={{border: '1px solid black', paddingTop: '15px'}}>
                    <>
                        <div className="d-flex justify-content-center">
                            <div className="col-3 themed-grid-col" style={{paddingRight: '10px'}}>
                                <div className="row">
                                    <div className="col-5">
                                        <label htmlFor="name" className="form-label">Número de Línea</label>
                                    </div>
                                    <div className="col-7">
                                        <input type="number" className="form-control" id="number" name="number"
                                               autoComplete="off" value={form.number} onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-5">
                                        <label htmlFor="name" className="form-label">Tipo de Línea</label>
                                    </div>
                                    <div className="col-7">
                                        <select className="form-select" aria-label="Default select example" id="type"
                                                name="type" value={form.type} onChange={handleChangeSelect}>
                                            <option value="">Seleccione</option>
                                            <option value="hogar">Hogar</option>
                                            <option value="movilPrepago">Movil Prepago</option>
                                            <option value="movilPostpago">Movil Postpago</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-5">
                                        <label htmlFor="numeroReportes" className="form-label">Numero de Reportes</label>
                                    </div>
                                    <div className="col-7">
                                        <input type="number" className="form-control" id="numeroReportes" name="numeroReportes"
                                               autoComplete="off" value={form.numeroReportes} onChange={handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 themed-grid-col" style={{paddingLeft: '10px', paddingRight: '10px'}}>
                                <div className="row">
                                    <div className="col-5">
                                        <label htmlFor="primerReporte" className="form-label">Primer Reporte </label>
                                    </div>
                                    <div className="col-7">
                                        <input type="date" className="form-control" id="primerReporte" name="primerReporte"
                                               autoComplete="off" value={form.primerReporte} onChange={handleChange}/>
                                    </div>
                                </div>
                             
                                <div className="row">
                                    <div className="col-5">
                                        <label htmlFor="ultimoReporte" className="form-label">Último Reporte</label>
                                    </div>
                                    <div className="col-7">
                                        <input type="date" className="form-control" id="ultimoReporte" name="ultimoReporte"
                                               autoComplete="off" value={form.ultimoReporte} onChange={handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 themed-grid-col" style={{paddingLeft: '10px'}}>
                                <div className="d-grid gap-2">
                                    {/*<button className="btn btn-info me-2" type="submit" onClick={handleSubmit}>{form._id ? 'Actualizar' : 'Guardar'}</button> */}
                                    {/*'btn btn-' + form._id ? 'info' : 'primary' + ' me-2'*/}
                                    <button className={'btn btn-' + (form._id ? 'success' : 'primary')} type="submit"
                                            onClick={handleSubmit}><i
                                        className="bi bi-save"/>{form._id ? 'Actualizar' : 'Guardar'}</button>
                                    <button type="reset" className="btn btn-secondary" onClick={handleReset}><i
                                        className="bi bi-eraser"/> Limpiar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>}
        </>
    );
}
export default LineCrudTableForm;
